import { DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { Settings } from "../../Settings";
import { GlobalUser } from "../GlobalUser";
import { JsonMenuItem } from "../json-data-types/JsonMenuItem";
import { ServerMenu } from "../server-queries/ServerMenu";
import { EnumIconNames } from "../enums/EnumIconNames";
import { Icon } from "./Icon";
import css from './MenuItem.m.scss'
import { SubMenu } from "./SubMenu";

interface Attrs{
    menuItem:JsonMenuItem
}
export class MenuItemSimple extends DomeComponent<Attrs>{
    refContainer!:HTMLDivElement
    refMenuItemText!:HTMLDivElement
    refCounter!:HTMLSpanElement
    refSubMenu!:SubMenu
    render(){
        return(
            <div ref={ref => this.refContainer = ref} class={css.menuItem}>
                <div ref={ref =>this.refMenuItemText = ref} class={css.menuItemText} onClick={() => this.onMenuItemClick() }>
                    <div>
                        <a href={Settings.addPrefixForUrl(this.attrs.menuItem.url)} 
                            onClick={(e) => this.onLinkClick(e)} 
                            class={css.topLevelLink}>
                                <p>{this.attrs.menuItem.name}</p>
                        </a>
                    </div>
                    <div class={css.counter} ref={ref => this.refCounter = ref}></div>
                </div>
            </div>
        )
    }


    protected onLinkClick(e){
        e.preventDefault()
    }

    protected onMenuItemClick(){
        if(this.refSubMenu){
            this.refSubMenu.show()
        } else {
            DomeRouter.navigate(Settings.addPrefixForUrl(this.attrs.menuItem.url))
        }
    }
 
    async afterRender(){
        if(await this.checkIfVisibleAsync(this.attrs.menuItem) === false){
            await DomeManipulator.removeElementAsync(this.rootElement)
            return
        }

        const subItems = await ServerMenu.getSubItemsSortedAsync(this.attrs.menuItem.id)
        if(subItems.length === 0) {
            return
        }

        await DomeManipulator.replaceAllChildrenAsync(this.refCounter, <>{subItems.length}<Icon iconName={EnumIconNames.RightOpen} /></>)

        await DomeManipulator.appendChildAsync(this.refContainer,
            <SubMenu ref={ref => this.refSubMenu = ref}>
                {subItems.map(item => <MenuItemSimple menuItem={item} />)}
            </SubMenu>
        )
    }

    protected async checkIfVisibleAsync(jsonTopMenuItem:JsonMenuItem){
        const userType = await GlobalUser.getUserTypeAsync()
        return jsonTopMenuItem.visibleFor.indexOf(userType)>=0
    }


}